export function filterCategoriesBySlugs(categories, slugs) {
  if (slugs.length === 0) return categories;
  var slugsSet = new Set(slugs);
  return categories.filter(function (category) {
    return slugsSet.has(category.slug);
  });
}